module.exports = __webpack_public_path__ + "5ddf868de2a46ee83503e6b6dc7db088.svg";